import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getClients = (filters, token, profileAccount_id) =>
    axios({
        method: 'get',
        url: `${api}/users?${makeQuery({ ...filters, profile: profileAccount_id })}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    });

export const postClients = (data, profileAccount_id, token) =>
    axios({
        method: 'post',
        url: `${api}/users`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/users`
        },
        data: {
            ...data,
            profile: profileAccount_id
        }
    });

export const putClients = (data, token) =>
    axios({
        method: 'put',
        url: `${api}/users/${data._id}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/users`
        },
        data: data
    });
